import type { RealestateAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { convertCurrency } from "../genericCalculations/convertCurrency";

export const calculateRealestateTotalSellingCosts = (
  userProduct: RealestateAsset
) => {
  const totalSellingCostsWithoutTax =
    calculateRealestateTotalSellingCostsWithoutTax(userProduct);

  const balance = userProduct?.value || 0;
  const profitTax = userProduct?.profitTax || 0;
  const purchasePrice = userProduct?.purchasePrice || 0;
  const purchaseExpenses = userProduct?.purchaseExpenses || 0;

  return (
    Number(totalSellingCostsWithoutTax) +
    ((Number(balance) -
      (Number(purchasePrice) +
        Number(purchaseExpenses) +
        Number(totalSellingCostsWithoutTax))) *
      profitTax) /
      100
  );
};

const calculateRealestateTotalSellingCostsWithoutTax = (
  userProduct: RealestateAsset
) => {
  const balance = userProduct?.value || 0;
  const generalSellingExpenses = userProduct?.generalSellingExpenses || 0;
  const legalExpenses = userProduct?.legalExpenses || 0;
  const isLegalExpensesPercentage = userProduct?.legalExpensesPercentage;
  const saleCommission = userProduct?.saleCommission || 0;

  const calculatedLegalExpenses = isLegalExpensesPercentage
    ? (legalExpenses * balance) / 100
    : legalExpenses;

  return (
    Number(generalSellingExpenses) +
    Number(calculatedLegalExpenses) +
    (saleCommission * balance) / 100
  );
};

export const calculateRealestateTotalSellingCostsBase = (
  userProduct: RealestateAsset,
  baseCurrency: Fiat,
  currentCurrency: Fiat
) => {
  const totalSellingCosts = calculateRealestateTotalSellingCosts(userProduct);

  return convertCurrency(
    Number(totalSellingCosts),
    baseCurrency,
    currentCurrency
  );
};

export const calculateRealestateTotalSellingCostsWithTax = (
  userProduct: RealestateAsset
) => {
  const balance = userProduct?.value || 0;
  const purchasePrice = userProduct?.purchasePrice || 0;
  const purchaseExpenses = userProduct?.purchaseExpenses || 0;
  const profitTax = userProduct?.profitTax || 0;
  const totalSellingCosts = calculateRealestateTotalSellingCosts(userProduct);

  const balanceWithTax =
    (balance - purchasePrice + purchaseExpenses + totalSellingCosts) *
    profitTax;

  return totalSellingCosts - balanceWithTax;
};
